/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import DTOLeaveHistory from "./DTOLeaveHistory";
import LeaveHistoryPresenter from "./LeaveHistoryPresenter";
import { useAppSelector } from "../../../../infra/hooks";
import { useTranslation } from "react-i18next";

function LeaveHistoryController() {
  const [allLeavesData, setAllLeavesData] = useState([]);
  const [yearFilter, setYearFilter] = useState<number>(0);
  const [typeFilter, setTypeFilter] = useState<string>('');

  const { t } = useTranslation();
  const isLoading = useAppSelector(
    (state) => state.leaveHistorySlice.refreshLeaveHistory
  );
  
  function callBackFunc(data: any) {
    setAllLeavesData(data);
  }

  const getYearFilter = (year: number) => {
    setYearFilter(year);
  };
  const getTypeFilter = (type: string) => {
    setTypeFilter(type);
  };
  return (
    <>
      <DTOLeaveHistory
        setEmpLeaveHistoryData={callBackFunc}
        yearFilter={yearFilter}
        typeFilter={typeFilter}
      />
      <LeaveHistoryPresenter
        leaveData={allLeavesData}
        setFilterYear={getYearFilter}
        setTypeFilter={getTypeFilter}
        isLoading={isLoading}
        trans={t}
      />
    </>
  );
}

export default LeaveHistoryController;
